import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./ContactUs.css";
// import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ContactUs = () => {
  // const [formData, setFormData] = useState({
  //   fullName: "",
  //   email: "",
  //   phone: "",
  //   // photoOfCollateral: null,
  //   collateralDescription: "",
  // });

  // // const [selectedImage, setSelectedImage] = useState(null);
  // // const fileInputRef = useRef(null);

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setFormData((prevData) => ({ ...prevData, [name]: value }));
  // };

  // // const handleImageUpload = (event) => {
  // //   const file = event.target.files[0];
  // //   if (file) {
  // //     setFormData((prevData) => ({
  // //       ...prevData,
  // //       photoOfCollateral: file,
  // //     }));

  // //     const reader = new FileReader();
  // //     reader.onloadend = () => {
  // //       setSelectedImage(reader.result); // Just for preview
  // //     };
  // //     reader.readAsDataURL(file);
  // //   }
  // // };

  // // const removeImage = () => {
  // //   setSelectedImage(null);
  // //   setFormData((prevData) => ({ ...prevData, photoOfCollateral: null }));
  // //   if (fileInputRef.current) {
  // //     fileInputRef.current.value = "";
  // //   }
  // // };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();

  //   const payload = {
  //     fullName: formData.fullName,
  //     email: formData.email,
  //     phone: formData.phone,
  //     // photoOfCollateral: formData.photoOfCollateral,
  //     collateralDescription: formData.collateralDescription,
  //   };

  //   try {
  //     const response = await fetch("https://formspree.io/f/mkgzvwwg", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (response.ok) {
  //       alert("Application submitted successfully!");
  //       setFormData({
  //         fullName: "",
  //         email: "",
  //         phone: "",
  //         // photoOfCollateral: null,
  //         collateralDescription: "",
  //       });
  //       // setSelectedImage(null);
  //       // if (fileInputRef.current) {
  //       //   fileInputRef.current.value = "";
  //       // }
  //     } else {
  //       alert("Error submitting application.");
  //     }
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //     alert("Failed to submit. Please try again.");
  //   }
  // };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Respected Solution",
            url: "https://www.respectedsolution.co",
            contactPoint: [
              {
                "@type": "ContactPoint",
                telephone: "+2349037614599",
                contactType: "customer service",
              },
            ],
            logo: "https://www.respectedsolution.co/assets/logo.png",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Respected Solution",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress:
                  "Suite N17-N19, Ikota Shopping Complex, Rd 4, Vgc, Ajah, Lekki 101222, Lagos.",
                addressLocality: "Lekki",
                postalCode: "101222",
                addressRegion: "Lagos",
                addressCountry: "NG",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "38b Adebayo Doherty Rd, Lekki Phase 1, Lekki 106104, Lagos",
                addressLocality: "Lekki",
                postalCode: "106104",
                addressRegion: "Lagos",
                addressCountry: "NG",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "96 Elelenwo Close GRA Phase II, Port Harcourt, Rivers State",
                addressLocality: "Port Harcourt",
                postalCode: "500211",
                addressRegion: "Port Harcourt",
                addressCountry: "NG",
              },
            ],
            telephone: "+2349037614599",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Contact Us",
            url: "https://www.respectedsolution.co/contact-us",
          })}
        </script>
      </Helmet>
      <div className="contact-hero">
        <h1>Contact Us</h1>
        <p>We're here to assist you. Reach out to us anytime!</p>
      </div>

      <div className="contact-container">
        <div className="loan-application-section">
          <h2>Need a Loan?</h2>
          <p>
            Ready to get started with your loan application? Click the button
            below to begin the process.
          </p>
          <a
            href="https://respectedsolution.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="apply-loan-btn"
          >
            Apply for Loan
          </a>
        </div>

        <div className="contact-info">
          <h2>Our Contact Details</h2>
          <p
            onClick={() =>
              (window.location.href =
                "https://maps.app.goo.gl/SEENu3i4dj52jHANA?g_st=iw")
            }
          >
            <FaMapMarkerAlt className="icon" /> Suite N17-N19, Ikota Shopping
            Complex, Rd 4, Vgc, Ajah, Lekki 101222, Lagos
          </p>
          <p
            onClick={() =>
              (window.location.href =
                "https://maps.app.goo.gl/X33QQ9jwJLZqpPPo9?g_st=iw")
            }
          >
            <FaMapMarkerAlt className="icon" /> 38b Adebayo Doherty Rd, Lekki
            Phase 1, Lekki 106104, Lagos
          </p>
          <p
            onClick={() =>
              (window.location.href =
                "https://maps.app.goo.gl/xgZvcEhauZ1NcJvq7?g_st=iwb")
            }
          
            >
            <FaMapMarkerAlt className="icon" /> 96 Elelenwo Close GRA Phase II,
            Port Harcourt, Rivers State
          </p>
          <p>
            <FaPhoneAlt className="icon" />
            <a href="tel:+2349037614599" className="contact-link">
              0903 761 4599
            </a>
          </p>
          <p>
            <FaPhoneAlt className="icon" />
            <a
              href="https://wa.me/2349114351195"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              WhatsApp +234 911 435 1195
            </a>
          </p>

          <p>
            <FaEnvelope className="icon" /> info@respectedsolution.co
          </p>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
